import yup, {
    integerPositiveValidator,
    integerNegativeAllowedValidator,
    imageValidator,
    booleanValidator,
    arrayValidator,
    cardNameValidator,
    ckEditorValidator,
} from '~/utils/validators.yup';
import { MAX_DESCRIPTION } from '~/config/constants';
import { statusDetailRule } from '../components/form-sections/StatusDetail/statusDetailRule';
import { cardTransformedDetailRule } from '../components/form-sections/CardTransformedDetail/cardTransformedDetailRule';
import { dvComparedDetailRule } from '../components/form-sections/DvComparedDetail/dvComparedDetailRule';
import { typeDetailRule } from '../components/form-sections/TypeDetail/typeDetailRule';
import { rewardPenaltyDetailRule } from '../components/form-sections/RewardPenaltyDetail/rewardPenaltyDetailRule';
import { conditionCheckDetailRule } from '../components/form-sections/ConditionCheckDetail/conditionCheckDetailRule';
import { conditionSuccessFailureDetailRule } from '../components/form-sections/ConditionSuccessFailureDetail/conditionSuccessFailureDetailRule';
import { conditionAfterDetailRule } from '../components/form-sections/ConditionAfterDetail/conditionAfterDetailRule';
import { conditionPassiveDetailRule } from '../components/form-sections/ConditionPassiveDetail/conditionPassiveDetailRule';
import { promptDetailRule } from '../components/form-sections/PromptDetail/promptDetailRule';
import { restrictionDetailRule } from '../components/form-sections/RestrictionDetail/restrictionDetailRule';
import { miscellaneousDetailRule } from '../components/form-sections/MiscellaneousDetail/miscellaneousDetailRule';

export const schema = (nullable = false) =>
    yup.object({
        name: cardNameValidator(),
        description: ckEditorValidator(MAX_DESCRIPTION),
        cardArt: imageValidator(nullable),
        icon: imageValidator(nullable),
        template: yup.object().shape({
            cardBack: imageValidator(true),
            cardFrame: imageValidator(true),
        }),
        keywords: arrayValidator,
        replacements: arrayValidator,
        basicDetail: yup.object().shape({
            startEffects: arrayValidator,
            modifiedDv1Value: integerNegativeAllowedValidator,
            modifiedDv2Value: integerNegativeAllowedValidator,
            attackModifiedValue: integerNegativeAllowedValidator,
            defenseModifiedValue: integerNegativeAllowedValidator,
            fixedDvValue: integerPositiveValidator,
            maxDvValue: integerPositiveValidator,
            damageValue: integerPositiveValidator,
            healedValue: integerPositiveValidator,
            hpValue: integerPositiveValidator,
            blockModifiedValue: integerPositiveValidator,
            duelEffects: arrayValidator,
            numberOfCardsToMoveValue: integerPositiveValidator,
            hitValue: integerPositiveValidator,
            penaltyDvValue: integerPositiveValidator,
            pointToStealValue: integerPositiveValidator,
            powerToRefresh: yup.mixed(),
            hasFirstStrike: booleanValidator,
            firstStrikeMultiHitValue: yup
                .number()
                .required()
                .when('hasFirstStrike', (hasFirstStrike, schema) =>
                    hasFirstStrike == false ? schema.oneOf([0], 'must be 0 as first strike is not enabled.') : schema,
                ), //https://stackoverflow.com/a/69003630/11297747
            effectPriorityValue: integerNegativeAllowedValidator,
            requiredHpToUpgradeValue: integerNegativeAllowedValidator,
            fixedStrikeValue: integerNegativeAllowedValidator,
            fixedBlockValue: integerNegativeAllowedValidator,
            afterDuelEffects: arrayValidator,
            persistentDvValue: integerPositiveValidator,
            persistentStrikeValue: integerPositiveValidator,
            onRevealEffects: arrayValidator,
            persistentBlockValue: integerPositiveValidator,
            opponentPersistentDvValue: integerPositiveValidator,
            opponentPersistentStrikeValue: integerPositiveValidator,
            opponentPersistentBlockValue: integerPositiveValidator,
        }),
        ...statusDetailRule,
        ...cardTransformedDetailRule,
        ...dvComparedDetailRule,
        ...typeDetailRule,
        ...rewardPenaltyDetailRule,
        ...conditionCheckDetailRule,
        ...conditionSuccessFailureDetailRule,
        ...conditionAfterDetailRule,
        ...conditionPassiveDetailRule,
        ...promptDetailRule,
        ...restrictionDetailRule,
        ...miscellaneousDetailRule,
    });
